<template>
 <v-container >

    <v-row class="d-flex" >
      <v-col cols="12" class="" >
         <p><b>Organizator</b></p>
         <p>Program lojalnosti korisnika (u daljem tekstu: Program), pod nazivom “Bilstein Group Club”, organizuje kompanija Ferdinand Bilstein South East Europe D.O.O. (u daljem tekstu: Organizator). </p>
         <p>Program se sprovodi u svrhu promocije proizvoda koje proizvodi Organizator.</p>
      </v-col>
      <v-col cols="12" class="" >
         <p><b>Trajanje, svrha i mesto odvijanja programa</b></p>
         <p>Program traje od 01.07.2026. godine do 31.10.2026. godine i odvija se na području Republike Srbije.</p>
      </v-col>
      <v-col cols="12" class="" >
         <p><b>Pravila Programa</b></p>
         <p>U programu učestvuju proizvodi sledećih brendova kupljeni u periodu trajanja programa:</p>
         <ul>
            <li>	febi bilstein</li>
            <li>	SWAG</li>
            <li>	Blue Print</li>	
         </ul>
       
      </v-col>
      <v-col cols="12" class="" >
         <p>Vrednost kupljenih proizvoda se pretvara u poene i to 100 RSD prometa = 4 poena u Programu. Korisnik je saglasan da se obračunava njegov promet u brendovima febi, SWAG i Blue Print ostvaren kod direktnih dobavljača obeleženih prilikom registovanja na platformu. Promet se obračunava po neto nabavnoj ceni (nakon odbitka rabata) bez PDV-a.</p>
         <p>Promet se obračunava jednom mesečno, svakog meseca tokom trajanja akcije, to jest od 01.07. do 31.10.2026.</p>
         <p>Nakon završetka programa, ukupni dobijeni poeni za sva tri brenda se pretvaraju u dinare na MasterCard poklon kartici, koja se učesniku izdaje za slobodnu potrošnju. Maksimalna vrednost koju učesnik može dobiti na MasterCard poklon kartici je 50.000 RSD, a minimalna 5.000 RSD. Za ostvarene iznose ispod 5.000 RSD neće se izdavati kartica. Za ostvarene iznose preko 13,248.00, obračunava se porez na dohodak građana za koji će učesniku biti umanjen iznos koji je ostvaren i koji se uplaćuje na MasterCard karticu. Učesnici mogu da preuzmu svoje MasterCard kartice u periodu od 01.11.2026. do 31.12.2026.</p>
      </v-col>
      <v-col cols="12" class="" >
        <p>Kako bi stekli pravo na nagradu, neophodno je da učesnici:</p>
        <ul class="numbers">
         <li>1.	Izvrše registraciju na platformi koja se nalazi na web adresi club.bilsteingroup.com sa tačnim podacima – Ime i prezime, PIB, ime auto servisa, adresa, broj mobilnog telefona.</li>
         <li> 2.	Izaberu dobavljače od kojih kupuju auto-delove  </li>
         <li> 3.	Potvrde da su saglasni sa ovim uslovima  </li>
         <li> 4.	Potvrde da su saglasni da dobijaju SMS poruke na uneseni broj telefona prilikom registracije. Te SMS poruka će sadržati trenutni broj poena korisnika i dodatne informacije. </li>
         </ul>
          <p>Organizator ne snosi odgovornost ukoliko korisnik do kraja trajanja Programa ne preuzme svoju MasterCard poklon karticu.</p>
          <p>U trenutku kada potrošač odabere preuzimanje MasterCard poklon kartice, odabir nagrade se ozvaničava i ne postoji mogućnost povratka poena na stanje pre porudžbine. Nakon isporuke kartice korisniku, prestaju sve obaveze Organizatora prema korisniku.</p>
          <p>Učesnik Programa u svako doba može proveriti trenutno stanje osvojenih poena na platformi koja se nalazi na web adresi club.bilsteingroup.com.</p>
          <p>Organizator zadržava pravo da kontaktira učesnika putem telefona ukoliko su mu potrebne dodatne informacije.</p>
          <p>Organizator zadržava pravo ali ne preuzima obavezu da na način koji slobodno izabere proverava validnost podataka o prometu. Podaci koji nisu validni su podaci koji su generisani ili izmišljeni a ne potvrđeni ili ukoliko je učesnik do njih došao na nedozvoljen način ili na način koji se protivi svrsi Programa, a to je promocija proizvoda Organizatora. U tu svrhu Organizator može zahtevati da mu pojedini učesnici dostave dokaze koji potvrđuju nabavku proizvoda.</p>
          <p>Navedene mehanizme i sredstva provere Organizator ima pravo da preduzme i u slučaju žalbe/prigovora učesnika da broj poena ne odgovara realnom stanju. U slučaju ponovljene žalbe/prigovora učesnik će dostaviti Organizatoru dokaze koji potvrđujuu nabavku proizvoda u zavisnosti koje sredstvo u konkretnom slučaju Organizator smatra pogodnim za utvrđivanje stvarnih činjenica.</p>
      </v-col>
      <v-col cols="12" class="" >
         <p><b>Izmena odrednica Programa</b></p>
         <p>Organizator zadržava pravo da za vreme trajanja Programa:</p>
        <ul class="numbers">
         <li>1.	Poveća broj / količinu nagrada;</li>
         <li> 2. Uvede dodatne specijalne nagrade, o čemu će obavestiti potrošače putem Platforme i SMS poruke na broj telefona unesen prilikom registracije najkasnije 3 dana pre početka nagrađjivanja;</li>
         <li> 3. Produži trajanje akcije omogućavajući učesnicima da skupe više poena. </li>
         </ul>
      </v-col>
      <v-col cols="12" class="" >
         <p><b>Pravo učestvovanja</b></p>
         <p>Pravo učešća u Programu imaju isključivo lica sa prebivalištem u Republici Srbiji bez Kosova i Metohije.</p>
         <p>Pravo učešća u Programu nemaju sledeća lica:</p>
          <ul>
            <li>		Lica koja su u radnom odnosu ili su na drugi način angažovana kod Organizatora kao i njihovi bračni drugovi, roditelji i deca;</li>
            <li>	Lica koja su u radnom odnosu ili su na drugi način angažovana kod pravnih lica koja na bilo koji način učestvuju u priređivanju i organizaciji Programa i/ili imaju pristup podacima vezanim za priređivanje Programa, kao i njihovi bračni drugovi, roditelji i deca.</li>
          </ul>
          <p>Učesnici Programa ne mogu da zahtevaju nagrade u većim količinama ili drugačije vrste nagrade od onih koje su definisane u ovim Pravilima od strane Organizatora. </p>
          <p>Učestvovanjem u Programu, učesnici prihvataju ova Pravila.</p>
      </v-col>
      <v-col cols="12" class="" >
        <p><b>Isporuka nagrada</b></p>
        <p>Nagrada (MasterCard poklon kartica) će korisnicima biti dostavljena po odabiru preuzimanja kartice, i to na adresu unesenu prilikom registracije.</p>
        <p>Svi lični podaci učesnika će biti prikupljani i obrađivani isključivo za svrhu sticanja prava učestvovanja u Programu i uručenje poklona, a biće čuvani u skladu sa propisima o zaštiti podataka o ličnosti.</p>
        <p>Organizator ne pokriva učesnicima troškove učestovanja.</p>
      </v-col>
      <v-col cols="12" class="" >
        <p><b>Maloletni učesnici</b></p>
        <p>Maloletna lica ne mogu da učestvuju samostalno u Programu. </p>
        <p>Ukoliko je učesnik maloletna osoba, potrebno je da njegov staratelj ili osoba koja je po zakonu ili odluci državnog organa dužna da se stara o njoj, unese svoje podatke pri registraciji poklona kako bi staratelj na osnovu istih mogao i da preuzme poklon.</p>
      </v-col>
      <v-col cols="12" class="" >
        <p><b>Kršenje pravila i zloupotrebe</b></p>
        <p>Ukoliko Organizator proceni da je došlo do kršenja pravila Programa i do njegove zloupotrebe na bilo koji način, ovlašćen je da uskrati isporuku nagrade učesniku koji je izvršio kršenje ili zloupotrebu i da ga privremeno ili trajno isključi iz daljeg učestvovanja u Programu. </p>

      </v-col>
      <v-col cols="12" class="" >
        <p><b>Žalbe i reklamacije</b></p>
        <p>U cilju što ažurnijeg rešavanja eventualnih primedbi na kvalitet poklona Organizator definiše ubrzanu proceduru rešavanja reklamacija, a kako sledi:</p>
        <p>U roku od 3 dana od dana preuzimanja poklona, dobitnik se može javiti Organizatoru preko besplatne info linije navedene u ovim Pravilima radi reklamacije, a takodje može poslati slike oštećenog poklona na email adresu club@bilsteingroup.com. Ukoliko je reklamacija opravdana, i ukoliko želi da mu oštećeni poklon bude zamenjen, dobitnik je dužan da pošalje oštećeni poklon na adresu Organizatora sa svojim podacima, nakon čega će mu Organizator dostaviti novi poklon. </p>
        <p>Reklamacije upućene Organizatoru nakon završetka promocije i definisanog krajnjeg datuma za preuzimanje poklona neće biti razmatrane.</p>
        <p>Ova procedura na utiče na prava dobitnika definisana propisima o zaštiti potrošača.</p>

      </v-col>
      <v-col cols="12" class="" >
        <p><b>Mogućnost prekida Programa</b></p>
        <p>Program može biti prekinut u slučaju nastupanja okolnosti za koje Organizator nije odgovoran, odnosno, koje niko nije mogao da spreči, otkloni ili izmeni.</p>
        <p>U slučaju prekida programa, učesnici će biti obavešteni putem sredstava javnog informisanja ili putem Platforme.</p>
      </v-col>
      <v-col cols="12" class="" >
        <p><b>Odgovornost</b></p>
        <p>Organizator ne preuzima odgovornost za bilo kakvu štetu koja nastane zloupotrebom ovog Programa, a koja se na taj način od strane učesnika ili trećih lica nanese bilo drugim učesnicima Programa, bilo trećim licima.</p>
        <p>Organizator takođe zadržava pravo izmene tehničke specifikacije poklona tj. prezentovane slike poklona nisu obavezujuće. </p>
      </v-col>
      <v-col cols="12" class="" >
        <p><b>Mogućnost izmene pravila Programa</b></p>
        <p>Organizator zadržava pravo da napravi određene izmene u pravilima Programa iz tehničkih, poslovnih ili razloga vezanih za javnost, bez diranja u stečena prava učesnika, kao i da u slučaju više sile obustavi odvijanje Programa.</p>
        <p>U slučaju bilo kakavih promena ili obustavljanja Programa, Organizator će obavestiti učesnike putem Platforme. </p>
      </v-col>
      <v-col cols="12" class="text-right" >
        <p><b>O R G A N I Z A T O R</b></p>
        <p><b>FERDINAND BILSTEIN SOUTH EAST EUROPE DOO</b></p>
      </v-col>

    </v-row>
 </v-container>
</template>

<script>
  import firebase from 'firebase'
  import {db,fb} from '../main'
  export default {
  
  name: 'Terms',
  data() {
    return {

    }
  },    

    methods: {

    },
      
}
</script>


<style>
  .numbers li {
    list-style: none;
  }
</style>